"use client";
import React, { useState, useEffect } from "react";
import { createBrowserHistory } from "history";
import {useLocation} from 'react-router-dom';
import {
  Studio,
  EquipmentCategory,
  RequestDetails,
  FormData,
  BookingType,
  EquipmentItem as EquipmentItemType,
} from "./types";
import { StudioSelectionStep } from "./StudioSelectionStep";
import { EquipmentSelectionStep } from "./EquipmentSelectionStep";
import { UserDetailsStep } from "./UserDetailsStep";
import { Header } from "./Header";
import ErrorToast from "./ErrorToast";

export const StudioBookingForm: React.FC = () => {

const minTime = 9;
const maxTime = 21;
const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;  

const base_host = window.location.host.includes('musestudios.ru')?'':'http://127.0.0.1:8000';


const [studios, setStudios] = useState<Studio[]>([
    {
      id: "0",
      name: "190",
      equip: "",
      size: 190,
      price: 3400,
      priceVideo: 3500,
      priceEvent: 3600,
      priceShort: 0,
      shortTill: 0,
      mindur: 3,
      image: "",
      aircon: true
    },    {
      id: "2",
      name: "french",
      equip: "",
      size: 100,
      price: 1000,
      priceVideo: 1500,
      priceEvent: 1900,
      priceShort: 500,
      shortTill: 3,
      mindur: 1,
      image: "",
      aircon: false
    }
  ]);




const [equipmentCategories, setEquipmentCategories] = useState<
    EquipmentCategory[]
  >([
    {
      id: "lighting",
      name: "СВЕТОВОЕ ОБОРУДОВАНИЕ",
      items: [
        {
          id: "led1",
          name: "LED прибор",
          price: 2000,
          icon: "",
          quantity: 0,
          busy: 0,
          maxQuantity: 2,
        }
      ],
    },
    {
      id: "sound",
      name: "ЗВУКОВОЕ ОБОРУДОВАНИЕ",
      items: [
        {
          id: "mic1",
          name: "Микрофон",
          price: 1000,
          icon: "",
          quantity: 0,
          busy: 0,
          maxQuantity: 2,
        }
      ],
    },
  ]);
  useEffect(() => {
    const api = async () => {
      try {
        let data = await fetch(base_host + "/b/rooms", {
          method: "GET"
        });
        //console.log("/b/rooms");
        setIsSelected(false);
        let jsonData = await data.json();
        setStudios(jsonData['result']);
      } catch (e) {
        console.log('Error loading data')
      }
    };
    api();
  }, []);

  useEffect(() => {
      if (!isSelected) {
        setSelectedStudio(studios[1]);
        setIsSelected(true);
      }
  }, [studios]);


  let step = -1;
  const browserHistory = createBrowserHistory();
  const setNav = (stateChange: boolean=false) => {
    let path = window.location.pathname;
    let sh = path.split('/');
    try {
      if(sh.length>1 && sh[1]!='book') {
        setCurrentStep(-1);
      }  
      if(sh.length>2) {
      
        if (!isNaN(parseInt(sh[2]))){
          step = parseInt(sh[2]);
          if(stateChange)
            setCurrentStep(step);
        }
      }
    } catch (e) {
    }
  }
  setNav();

  useEffect(() => {
    browserHistory.listen((update) => {
      if (update.action === "POP") {
        //console.log("POP")
        //console.log(update.location.pathname.substr(0,5))
        if (update.location.pathname.substr(0,5)!='/book') {
          setIsSelected(false);
        }
        setNav(true);
      }
    });
  }, []);

  const [currentStep, setCurrentStep] = useState(step);
  const [bookingType, setBookingType] = useState<BookingType>("foto");
  const [studioRef, setStudioRef] = useState<any>(null);
  const [duration, setDuration] = useState(0);
  const [maxDuration, setMaxDuration] = useState(maxTime - minTime);
  const [backUrl, setBackUrl] = useState('/');
  const [visitors, setVisitors] = useState(1);
  const [selectedStudio, setSelectedStudio] = useState<Studio>(studios[0]);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<number | null>(null);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState<string[]>([]);
  const [isSelected, setIsSelected] = useState(false);
  const [occupiedSlots, setOccupiedSlots] = useState<Record<string, number[]>>({
    "2025-05-09": [10,11,12],
    "2025-05-10": [14,15],
  });

  const [sunnySlots, setSunnySlots] = useState<Record<string, number[]>>({
    "2025-05-27": [10,11,12],
    "2025-05-28": [14,15],
  });

  useEffect(() => {
    const selectedElement = document.querySelector('[data-studio-id="'+selectedStudio.id+'"]');
    if (selectedElement) {
      selectedElement.scrollIntoView({ 
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
    const api = async () => {
      try {
        setSelectedDate(null);
        setSelectedTimeSlot(null);
        setDuration(0);
        if (selectedStudio.id!=='0'){
                const data = await fetch(base_host + "/b/occupied/"+selectedStudio.id, {
                  method: "GET"
                });
                const jsonData = await data.json();
                //console.log(jsonData);
                setOccupiedSlots(jsonData['result']['occupied']);
                setSunnySlots(jsonData['result']['sunny']);
        }
      } catch (e) {
          console.log('Error loading data')
      }
    };
    api();
  }, [selectedStudio]);

  useEffect(() => {
    if (currentStep==0) {
      (window as any).ym(99704382,'reachGoal','schedule');
    } else if (currentStep==1) {
      (window as any).ym(99704382,'reachGoal','extraServices');
    } else if (currentStep==2) {
      (window as any).ym(99704382,'reachGoal','personalInfo');
    }
    let isSelectedLocal = false;
    if (currentStep==0) {

      if (!isSelected) {
        //console.log(backUrl);
        let p = window.location.pathname.split("/");
        let selStudio = '';
        if (p.length == 5 && p[3]=='s') {
          selStudio = p[4];
        } else if (p.length == 3 && p[1]=='studios') {
          selStudio = p[2];
        }
        if (selStudio!='') { 
          studios.forEach((item) => {
            if(item.id == selStudio) {
              setSelectedStudio(item);
              isSelectedLocal = true;
            }
          });

        } 
      }
      if (!isSelectedLocal && !isSelected) {
        setSelectedStudio(studios[1]);
        setSelectedDate(null)
        //setIsSelected(true);
      }
    }
    if (currentStep==1) {
      const api = async () => {
        try {
          let data = await fetch(base_host + "/b/equip/" + selectedStudio.id + "/" + selectedDate + "T" + selectedTimeSlot + "/" + duration, {
            method: "GET"
          });
          let jsonData = await data.json();
          setEquipmentCategories(jsonData['result']);
        } catch (e) {
            console.log('Error loading data')
        }
      };
      api();
    }
    if (currentStep>=0) {
      const selectedElement = document.querySelector('.App div');
      if (selectedElement) {
        selectedElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        });
      }
    }
  }, [currentStep]);

  const [timeSlots, setTimeSlots] = useState(() =>
    Array.from({ length: 13 }, (_, i) => i + 9),
  );

  const [dates, setDates] = useState(() =>
    Array.from({ length: 80 }, (_, i) => {
      const date = new Date();
      date.setDate(date.getDate() + i);
      return date;
    }),
  );

  const [requestDetails, setRequestDetails] = useState<RequestDetails>({
    room: "190",
    bookType: "foto",
    visitors:1, 
    equipment: [],
    dateTime: new Date("2024-05-12 14:00"),
    duration: 2,
    totalAmount: 15000,
  });

  const [formData, setFormData] = useState<FormData>({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    promo: "",
    comment: "",
    isCompany: false,
    agreed: false,
    agreedPers: false,
    loading: false
  });

  const startBooking = () => {
    //console.log("startBooking");
    setIsSelected(false);
    setBackUrl(window.location.pathname);
    //console.log('backUrl', backUrl);
    let p = window.location.pathname.split("/");
    let url = '/book/0';

    if (p.length == 3 && p[1]=='studios') {
      url += '/s/'+p[2]
    }

    window.history.pushState({}, '', url);
    setCurrentStep(0);
  }

  const setCurStep = (step: number) => {
    if (step==-1) {
      //console.log('setCurStep backUrl', backUrl);
      window.history.pushState({}, '', backUrl)
      //navigate('/book/'+step, {replace: true});
    } else if (currentStep - step == 1) {
      //console.log('setCurStep window.history.back()');
      window.history.back()
      //navigate(-1)
    } else {
      window.history.pushState({}, '', '/book/'+step);
      //navigate('/book/'+step);
    }
    setCurrentStep(step);
  }

  const toggleTimeSlot = (date: string, time: number) => {
    const slotKey = `${date}-${time}`;
    const isOccupied = occupiedSlots[date]?.includes(time);
    if (!isOccupied) {
      const selectedElement = document.querySelector('#time-slots');
      if (selectedElement) {
        selectedElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        });
      }
      if (selectedDate != date || selectedTimeSlot === null || time<selectedTimeSlot) {
        let i = time;
        for (i = time; i <= maxTime; i++) {
          if (occupiedSlots[date]?.includes(i)) {
            //i--;
            break;
          }
        }
        if (i - time  < selectedStudio.mindur)
          return false;
        setMaxDuration(i - time);

        setSelectedDate(date);
        setIsSelected(true);
        setSelectedTimeSlot(time);
        setDuration(selectedStudio.mindur);
      } else {
        let dur = time-selectedTimeSlot+1;
        if (dur < selectedStudio.mindur)
          return;
        if (dur > maxDuration)
          dur = maxDuration;
        setDuration(dur);
      }
    }
  };

  const updateQuantity = (itemId: string, delta: number) => {
    setEquipmentCategories((prev) =>
      prev.map((category) => ({
        ...category,
        items: category.items.map((item) => {
          if (item.id === itemId) {
            return {
              ...item,
              quantity: Math.max(0, (item.quantity || 0) + delta),
            };
          }
          return item;
        }),
      })),
    );
  };

  const getStudioEquip = () => {
    if (selectedStudio.equip == '' || selectedStudio.equip == 'None')
      return '';
    else
      return "Напоминалка! В зале " + selectedStudio.name + " уже есть:\n" + selectedStudio.equip;
  }

  const getTotalAmount = () => {
    let p = selectedStudio.price;
    let p_add = 0;
    
    if (!isSelected)
      return 0;
    if (bookingType == 'video')
      p = selectedStudio.priceVideo;
    if (bookingType == 'event')
      p = selectedStudio.priceEvent;
    if (selectedStudio.priceShort>0 && selectedStudio.shortTill>duration)
      p_add = selectedStudio.priceShort
    return p_add + (p*duration) + equipmentCategories
      .flatMap((cat) => cat.items)
      .reduce((sum, item) => sum + item.price * (item.quantity || 0), 0);
  };

  const getTotalTip = () => {
    if (selectedDate===null)
      return ""
    let sd = selectedDate.substr(selectedDate.length - 5)
    if (sd == "01-01" || sd == "01-02" || sd == "01-03" || sd == "01-04")
      return "Для бронирования в праздничные дни свяжитесь с нами минимум за 24 часа до предполагаемой аренды"
    return ""
  };

  const handleFormDataChange = (field: keyof FormData, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getSelectedEquip = () => {
    requestDetails.room = selectedStudio.name;
    requestDetails.bookType = bookingType;
    requestDetails.visitors = visitors;
    if (selectedTimeSlot !== null && selectedDate !== null)
      requestDetails.dateTime = new Date(selectedDate + " " + selectedTimeSlot.toString() + ":00");
    requestDetails.duration = duration;
    let ret:EquipmentItemType[] = [];
    equipmentCategories.forEach((cat) => {
      cat.items.forEach((item) => {
        if(item.quantity>0)
          ret.push(item);
      });
    });
    return ret;
  };

  const getFormEquip = () => {
    let ret:{'id': string, 'qty': number}[] = [];
    equipmentCategories.forEach((cat) => {
      cat.items.forEach((item) => {
        if(item.quantity>0)
          ret.push({ 'id': item.id, 'qty': item.quantity });
      });
    });
    return ret;
  };

  const [error, setError] = useState<Error | null>(null);

  const showError = (msg:string) => {
    setError(new Error(msg));
  };

  const clearError = () => {
    setError(null);
  };

  const handleSubmit = (e:any) => {
    e.preventDefault();

    // Handle form submission logic here
    if(formData.firstName && formData.lastName && formData.phone && formData.email.match(isValidEmail) && formData.agreed && formData.agreedPers) {
      handleFormDataChange('loading', !formData.loading);
        const api = async () => {
        try {
          let body = {
              'room': selectedStudio.id,
              'date_from': selectedDate + " " + selectedTimeSlot + ":00:00",
              'duration': duration,
              'visitors': visitors,
              'book_type': bookingType,
              'first_name': formData.firstName,
              'last_name': formData.lastName,
              'email': formData.email,
              'phone': formData.phone,
              'source': 'WEB',
              'comment': formData.comment,
              'promo': formData.promo,
              'isCompany': formData.isCompany,
              'equip': getFormEquip(),
          }
          let data = await fetch(base_host + "/b/book", {
            headers: {
              'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(body)
          });
          let jsonData = await data.json();
          if (jsonData['result']['type'] == "error") {
            handleFormDataChange('loading', false);
            showError(jsonData['result']['message']);
          } else {
            window.location.href = 'https://musestudios.ru/b/p/'+jsonData['result']['key'];
          }
        } catch (e) {
          //console.log(e);
          console.log('Error loading data');
        }
      };
      api();
    } else {
      console.log('form not filled');
    }
  };
  return (
    <>
          <ErrorToast
            error={error}
            onClose={clearError}
          />
          {currentStep === -1 && (
            <>
          <button
            className="flex gap-2 items-center px-4 py-3 text-xs bg-black cursor-pointer border-[none] text-[white] max-sm:justify-center max-sm:w-full"
            id="book_button"
            onClick={() => startBooking()}
          >
            <span className="text-white font-light text-s">ЗАБРОНИРОВАТЬ</span>
            <div className="bg-amber-500 rounded h-[5px] w-[5px]" />
          </button>
          </>
        )}

        {currentStep === 0 && (
          <div className="bg-white top-0 left-0 z-20 absolute h-full min-h-screen w-full px-5 py-10 mx-auto my-0 bg-white max-sm:p-5">
            <div className="bg-white justify-self-center w-[calc(100vw_-_50px)] max-w-[1400px] max-sm:w-full max-sm:min-w-80">
              <Header
                onClose={() => setCurStep(-1)}
              />
              <StudioSelectionStep
                studios={studios}
                selectedStudio={selectedStudio} 
                bookingType={bookingType}
                duration={duration}
                maxDuration={maxDuration}
                visitors={visitors}
                dates={dates}
                timeSlots={timeSlots}
                selectedTimeSlots={selectedTimeSlots}
                selectedDate={selectedDate}
                selectedTime={selectedTimeSlot}
                occupiedSlots={occupiedSlots}
                sunnySlots={sunnySlots}
                onStudioSelect={setSelectedStudio}
                onBookingTypeChange={setBookingType}
                onDurationChange={setDuration}
                onVisitorsChange={setVisitors}
                onToggleTimeSlot={toggleTimeSlot}
                getTotalAmount={getTotalAmount}
                getTotalTip={()=>getTotalTip()}
                onNextStep={() => setCurStep(1)}
              />
            </div>
            <div className="py-6"/>
          </div>
        )}

        {currentStep === 1 && (
          <div className="bg-white top-0 left-0 z-20 absolute h-full min-h-screen w-full px-5 py-10 mx-auto my-0 bg-white max-sm:p-5">
            <div className="bg-white justify-self-center w-[calc(100vw_-_50px)] max-w-[1400px] max-sm:w-full max-sm:min-w-80">
              <Header
                onClose={() => setCurStep(-1)}
              />
              <EquipmentSelectionStep
                equipmentCategories={equipmentCategories}
                onUpdateQuantity={updateQuantity}
                getTotalAmount={getTotalAmount}
                getTotalTip={()=>getTotalTip()}
                getStudioEquip={getStudioEquip}
                onPrevStep={() => setCurStep(0)}
                onNextStep={() => setCurStep(2)}
              />
            </div>
            <div className="py-6"/>
          </div>
        )}

        {currentStep === 2 && (requestDetails.equipment=getSelectedEquip()) && (
          <div className="bg-white top-0 left-0 z-20 absolute h-full min-h-screen w-full px-5 py-10 mx-auto mt-0 bg-white max-sm:p-5">
            <div className="bg-white justify-self-center w-[calc(100vw_-_50px)] max-w-[1400px] max-sm:w-full max-sm:min-w-80">
              <Header
                onClose={() => setCurStep(-1)}
              />
              <UserDetailsStep
                requestDetails={requestDetails}
                formData={formData}
                onFormDataChange={handleFormDataChange}
                onPrevStep={() => setCurStep(1)}
                getTotalAmount={()=>getTotalAmount()}
                getTotalTip={()=>getTotalTip()}
                onSubmit={handleSubmit}
              />
            </div>
            <div className="py-6"/>
          </div>
        )}

        </>
  );
};

export default StudioBookingForm;
